import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SnackbarService } from '../../../snackbar/service/snackbar.service';
import { EditFacModalService } from '../../service/edit-fac-modal.service';

@Component({
  selector: 'app-client-chat',
  templateUrl: './client-chat.component.html',
  styleUrls: ['./client-chat.component.scss']
})
export class ClientChatComponent {
  @Input() messages = [];
  @Output() resend = new EventEmitter<any>();


  resendEmail(message) {
    this.resend.emit(message.id);
  }
}
